import { render, staticRenderFns } from "./EmailCreate.vue?vue&type=template&id=83a1f250&scoped=true&"
import script from "./EmailCreate.vue?vue&type=script&lang=js&"
export * from "./EmailCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a1f250",
  null
  
)

export default component.exports